import { mapActions, mapState, mapMutations } from "vuex";
import { EVENTS } from "@/utils";
import AppDropdown from "@/components/AppDropdown";
import AppButton from "@/components/AppButton";
import AppIcon from "@/components/AppIcon";
import FlexRow from "@/components/FlexRow.vue";
import SellerFilter from "@/components/new-filters/SellerFilter.vue";
import SegmentFilter from "@/components/new-filters/SegmentFilter.vue";
import EmptySegments from "@/components/EmptySegments.vue";
import AccountsMixin from "@/mixins/AccountsMixin.vue";
import SheetIcon from "@/components/icons/SheetIcon.vue";
import CSVIcon from "@/components/icons/CSVIcon.vue";
import AppDropdownItem from "@/components/AppDropdownItem.vue";
import ProductFilter from "@/components/new-filters/ProductFilter.vue";
import LiteTableMixin from "@/mixins/LiteTableMixin.vue";
export default {
  name: "DemandForecastingTop",
  mixins: [AccountsMixin, LiteTableMixin],
  emits: ["create-inventory-order", "generate-google-sheet"],
  components: {
    AppDropdown,
    AppButton,
    AppIcon,
    FlexRow,
    SellerFilter,
    SegmentFilter,
    EmptySegments,
    SheetIcon,
    CSVIcon,
    AppDropdownItem,
    ProductFilter
  },
  props: {
    selected: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      item: "omny",
      options: [{
        value: "omny",
        text: "Omny"
      }],
      sellers: [],
      options: [{
        value: "imperial",
        text: "Imperial"
      }, {
        value: "metric",
        text: "Metric"
      }],
      order_options: [{
        value: "csv",
        text: "Raw CSV",
        sub_category: "unprocessed",
        icon: "CSVIcon",
        mix_panel_event: "demandForecastingExport"
      }, {
        value: "box_level",
        text: "Box level fulfillment template",
        sub_category: "intermediate",
        icon: "SheetIcon",
        mix_panel_event: "demandForecastingBoxLevelOrderPlaced"
      }, {
        value: "pick_and_pack",
        text: "Pick and Pack fulfillment template",
        sub_category: "intermediate",
        icon: "SheetIcon",
        mix_panel_event: "demandForecastingPickAndPackOrderPlaced"
      }
      // { value: "csv", text: "Amazon template", sub_category: 'processed', icon: "CSVIcon"}
      ],
      order_options_categories: ["unprocessed", "intermediate"]
    };
  },
  computed: {
    ...mapState({
      sellers_filter: state => state.demand_forecasting.sellers_filter,
      itemScaleType: state => state.workspace.scaleType,
      products_filter: state => state.demand_forecasting.products_filter,
      segments_filter: state => state.demand_forecasting.segments_filter,
      keyword_list: state => state.demand_forecasting.keyword_list
    })
  },
  methods: {
    ...mapMutations(["demandForecastingSellersFilterSet"]),
    ...mapActions(["inventoryCreateOrderCsv"]),
    async applySellers() {
      if (this.sellers_filter.isModified) {
        this.sellers_filter.apply();
        this.products_filter.clearAndApply();
        this.segments_filter.clearAndApply();
        window.$bus.trigger("showSuccess", {
          message: "⏳Fetching sub filters for sellers...  ",
          visible: true,
          delay: 10
        });
        await window.$bus.trigger(EVENTS.REFRESH_DEMAND_FORECASTING_SELLERS_SUB_FILTERS);
        window.$bus.trigger("showSuccess", {
          visible: false,
          message: ""
        });
        await window.$bus.trigger(EVENTS.REFRESH_DEMAND_FORECASTING_PAGE);
      }
    },
    async clearSellers() {
      if (this.sellers_filter.isModified) {
        this.sellers_filter.clear();
        this.sellers_filter.selectOnly(this.sellers_filter.filterItems.slice(-1).pop(), "id");
        window.$bus.trigger("showSuccess", {
          message: "⏳Refreshing ...  ",
          visible: true,
          delay: 10
        });
        await window.$bus.trigger(EVENTS.REFRESH_DEMAND_FORECASTING_PAGE);
      }
    },
    async applySegments() {
      if (this.segments_filter.isModified) {
        this.segments_filter.apply();
        window.$bus.trigger("showSuccess", {
          message: "⏳Fetching product filters for segments...  ",
          visible: true,
          delay: 50
        });
        await window.$bus.trigger(EVENTS.REFRESH_DEMAND_FORECASTING_PRODUCTS_SUB_FILTERS);
        window.$bus.trigger(EVENTS.REFRESH_DEMAND_FORECASTING_PAGE);
      }
    },
    async clearSegments() {
      if (this.segments_filter.isModified) {
        this.segments_filter.clear();
        window.$bus.trigger("showSuccess", {
          message: "⏳Refreshing...  ",
          visible: true,
          delay: 10
        });
        await window.$bus.trigger(EVENTS.REFRESH_DEMAND_FORECASTING_PAGE);
      }
    },
    onCreateInventoryOrder() {
      window.$bus.trigger("showSuccess", {
        message: "Creating Order csv for download ...  ",
        visible: true,
        delay: 10
      });
      this.$emit("create-inventory-order");
    },
    async handleScaleTypeChange(newScaleType) {
      //console.log("[selected scale option]:", newScaleType);
      await window.$bus.trigger(EVENTS.CHANGE_PRODUCT_DATA_SCALE, newScaleType);
    },
    async handleOrder(order_option) {
      if (order_option.value == "csv") {
        this.onCreateInventoryOrder();
        window.$bus.trigger(EVENTS.MIXPANEL_TRACK, {
          event_name: order_option.mix_panel_event,
          properties: {}
        });
        return;
      }
      window.$bus.trigger(EVENTS.MIXPANEL_TRACK, {
        event_name: order_option.mix_panel_event,
        properties: {}
      });
      window.$bus.trigger("showSuccess", {
        message: "Generating Google Sheet ...  ",
        visible: true,
        delay: 10
      });
      this.$emit("generate-google-sheet", order_option.value);
    },
    applyProducts() {
      if (this.products_filter.isModified) {
        this.products_filter.apply();
        window.$bus.trigger(EVENTS.REFRESH_DEMAND_FORECASTING_PAGE);
      }
    },
    async clearProducts() {
      this.products_filter.clear();
      window.$bus.trigger("showSuccess", {
        message: "⏳Refreshing...  ",
        visible: true,
        delay: 10
      });
      await window.$bus.trigger(EVENTS.REFRESH_DEMAND_FORECASTING_PAGE);
    }
  }
};